<div class="uk-card uk uk-card-body uk-border-rounded uk-background-default uk-padding">
    <div class="uk-text-center" *ngIf="lineModalTemplate.icon">
        <img src="{{lineModalTemplate.icon}}">
    </div>
    <h3 class="uk-text-center uk-margin-remove-top">
        {{lineModalTemplate.title}}
    </h3>
    <div class="uk-text-center uk-padding-small uk-margin-bottom per-line">
        <p class="uk-margin-remove" *ngFor="let item of body">{{item}}</p>
    </div>
    <div class="uk-flex uk-flex-center">
        <div class="uk-text-center" uk-grid  *ngIf="lineModalTemplate.type === 'confirm'">
            <div>
                <button class="uk-button uk-button-default uk-border-rounded" (click)="onSubmit()">ตกลง</button>
            </div>
            <div>
                <button class="uk-button uk-button-primary uk-border-rounded" (click)="onCancel()">ยกเลิก</button>
            </div>
        </div>
        <div class="uk-text-center" uk-grid  *ngIf="lineModalTemplate.type === 'alert'">
            <div>
                <button class="uk-button uk-button-primary uk-border-rounded" (click)="onCancel()">ตกลง</button>
            </div>
        </div>
    </div>
</div>